export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { value: '100+', label: '每日更新话数' },
    { value: '5,000+', label: '收录动漫作品' },
    { value: '日·国·韩', label: '三语动漫全覆盖' },
  ];

  return (
    <section id="hero" className="relative min-h-screen pt-16 flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl"></div>
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>日漫</span>
              <span className="text-foreground-300">·</span>
              <span>国漫</span>
              <span className="text-foreground-300">·</span>
              <span>韩漫</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              51动漫网<span className="text-primary-500">·</span>您的免费动漫在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-4">
              汇聚全网热门动漫，畅享下拉式追更体验
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              51动漫网作为一站式动漫在线阅读平台，为您精心筛选日漫、国漫、韩漫等热门作品。
              每日同步更新最新话数，支持流畅的下拉式阅读体验，无需注册即可免费畅读。
              无论您是热血少年漫爱好者，还是偏爱治愈系日常番，这里都有属于您的那一部。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-medium rounded-md hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer text-center"
              >
                开始阅读 <i className="ri-arrow-right-line ml-1"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="w-full sm:w-auto px-8 py-3 border border-background-300 text-foreground-700 font-medium rounded-md hover:bg-background-100 transition-colors text-sm whitespace-nowrap cursor-pointer text-center"
              >
                热门排行 <i className="ri-trophy-line ml-1"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20anime%20manga%20reading%20scene%20with%20illustrated%20characters%20on%20a%20digital%20tablet%20screen%2C%20warm%20cozy%20reading%20nook%20with%20soft%20ambient%20lighting%2C%20Japanese%20manga%20volumes%20stacked%20nearby%2C%20cherry%20blossom%20petals%20floating%20gently%2C%20modern%20minimalist%20interior%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20artistic%20storytelling%20atmosphere%2C%20editorial%20photography%20style%20with%20soft%20shadows&width=800&height=600&seq=51anime-hero&orientation=landscape"
                alt="51动漫网 - 在线动漫阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}